/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const UnitySvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.1em"
    height="1.1em"
    viewBox="0 0 50 50"
    fill="currentColor"
  >
    <path d="M44.082 25.207l2.82-4.777a1 1 0 00.043-.758l-5.586-16a1.002 1.002 0 00-1.18-.645l-16.417 4c-.313.078-.57.301-.692.602L21.324 12H16c-.277 0-.547.117-.734.32l-12 13a1 1 0 00.043 1.403l12.586 12c.183.18.433.277.687.277h5.738l1.75 4.371a.998.998 0 00.758.613l17.461 3a.998.998 0 001.145-.77l3.543-16.23a.993.993 0 00-.125-.734zM21.324 12l14.094-2.582L28 24H11.168zm1 27L11.168 28H28l8.75 13.168zm18.063-.102L32 26l7.332-14.582 4.75 13.793z"></path>
  </svg>

);

export const UnityIcon = (props) => (
  <Icon component={UnitySvg} {...props} />
);

